import store from "../../../store/store";
import TimeStamp from "../../timeStamp";
import SPIELER_MEMBERSHIP_HANDLER from "./spielerMembershipHandler";
import {db} from "@/services/db";
import FirebaseRead from "@/services/database/firebaseRead";
//import SPIELER_MEMBERSHIP_HANDLER from "./spielerMembershipHandler";
//import {firestore} from "../../db";

export default class SPIELER_CHANGE_HANDLER {

// general Support Functions
    static getYearFromDateString(dateString){
        return parseInt(dateString.split('-')[0])
    }

// getters e.g. for table views
    static getPassNumberForSportJahrValue(spieler){ // , sportJahrValue, leihe
        // OLD: needed for sportjahr selection
        /*let sportJahr = store.state.local.sportJahr.getObjectFromSportJahrValue(sportJahrValue);
        let passNr = '';
        spieler.memberships.forEach( (membership) => {
            if ( sportJahr.from >= membership.from && sportJahr.until <= membership.until  ) {
                passNr = membership.passNr;
            }
        });*/
        let membership = SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(spieler.memberships);
        return  membership.passNr;
    }
    static getLastLvVereinNr(spieler){
        let lastLvVereinNr = '';
        let until = '';
        Object.keys(spieler.lvVerein).forEach( (vereinNr) => {
            if ( spieler.lvVerein[vereinNr].until > until || lastLvVereinNr === '' ) {
                lastLvVereinNr = vereinNr;
                until = spieler.lvVerein[vereinNr].until;
            }
        });
        return lastLvVereinNr;
    }
    /*static getChangesObjectFromActionItem(actionItem, lvId){
        let changes = {};
        actionItem.changes.forEach( (item) => {
            if ( item.field === 'vereinsNr' ) {
                changes.vereinOld = lvId + '' + item.valueOld;
                changes.vereinNew = lvId + '' + item.valueNew
            } else {
                changes.lastSportTagOld = item.valueOld;
                changes.lastSportTagNew = item.valueNew
            }
        });
        return changes;
    }*/

// GETTERS on searchKeys
    static getVereinFromSportJahrValue(spieler, sportJahrValue){
        let verein = '';
        Object.keys(spieler.search.membershipYears).forEach( (year) => {
            let i = year.indexOf(sportJahrValue);
            if ( i !== -1 ) { verein = year.substr(0, i-1)}
        });
        return verein;
    }

// ABMELDUNG
    static getDataObjectForAbmeldung( spieler, deleteOption, actionDate ) {
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = store.state.local.sportJahr.abmeldung.until;
        if ( deleteOption !== 'sportJahr' ) {
            path = 'dates.gesperrtAb';
            dbObject[path] = actionDate;
        }
        dbObject.status = 'inaktiv';
    // get new memberships
        dbObject.memberships = SPIELER_MEMBERSHIP_HANDLER.getAbmeldung(spieler);
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( spielerTemp.search,
                                                                            dbObject.memberships, 'inaktiv' );
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(dbObject.search, spielerTemp.ade, spielerTemp.dsv,
                                                                                'inaktiv');
    // return change object
        return dbObject
    }

    /*static getDataObjectForAbmeldungCancel(spieler, pendingAction){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let memberships = pendingAction.undo_pending.memberships;
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(memberships);
        path = 'dates.gesperrtAb';
        dbObject[path] = '';
        dbObject.status = 'aktiv';
    // reset memberships
        dbObject.memberships = memberships;
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( spielerTemp.search, dbObject.memberships, 'aktiv' );
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(dbObject.search, spielerTemp.ade, spielerTemp.dsv,
                                                                                'aktiv');
    // return change object
        return dbObject
    }*/

    static getDataObjectForCancel(spieler, pendingAction, actionType){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let memberships = pendingAction.undo_pending.memberships;
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(memberships);
        path = 'dates.gesperrtAb';
        dbObject[path] = actionType === 'wiederanmeldung' ? pendingAction.undo_pending.gesperrtAb : '';
        const statusTemp = actionType === 'wiederanmeldung' ? 'inaktiv' : 'aktiv';
        dbObject.status = statusTemp;
    // reset memberships
        dbObject.memberships = memberships;
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
                                    spielerTemp.search, dbObject.memberships, statusTemp );
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(
                                    dbObject.search, spielerTemp.ade, spielerTemp.dsv, statusTemp);
    // return change object
        return dbObject
    }

// WIEDERANMELDUNG
    static getDataObjectForWiederanmeldung( spieler, selectedSportJahr, lv ) {
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let sportJahr = store.state.local.sportJahr.getObjectFromSportJahrValue(selectedSportJahr);
        let validityRange = SPIELER_CHANGE_HANDLER.getPassValidityRange(spieler.private.geburtsdatum,
                                                                        lv.sportart, sportJahr);
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = validityRange.until;
        path = 'dates.gesperrtAb';
        dbObject[path] = '';
        dbObject.status = 'aktiv';
    // get new memberships
        dbObject.memberships = SPIELER_MEMBERSHIP_HANDLER.getWiederanmeldung(spieler, validityRange);
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
                                                spielerTemp.search, dbObject.memberships, 'aktiv' );
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(
                                                dbObject.search, spielerTemp.ade, spielerTemp.dsv, 'aktiv');
    // set search key for this year in case of wiederanmeldung in the future
        if ( store.state.local.sportJahr.current.from < sportJahr.from ) {
            Object.keys( dbObject.search.membershipYears ).forEach( (year) => {
                if ( year.indexOf(sportJahr.value) !== -1 ) {
                    const membershipYear = year.substr(0,5) + '_' + store.state.local.sportJahr.current.value;
                    dbObject.search.membershipYears[membershipYear] = true;
                }
            });
        }
    // return change object
        return dbObject
    }

    /*static getDataObjectForWiederanmeldungCancel(spieler, pendingAction){
        console.log ("SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS 1" );
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let memberships = pendingAction.undo_pending.memberships;
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(memberships);
        path = 'dates.gesperrtAb';
        dbObject[path] = pendingAction.undo_pending.gesperrtAb;
        dbObject.status = 'inaktiv';
    // reset memberships
        dbObject.memberships = memberships;
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( spielerTemp.search, dbObject.memberships, 'inaktiv' );
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(dbObject.search, spielerTemp.ade, spielerTemp.dsv,
                                                                                'inaktiv');
    // return change object
        return dbObject
    }*/

// VERLÄNGERUNG
    static getDataObjectForVerlaengerung( spieler, sportJahr, lv ) {
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let validityRange = SPIELER_CHANGE_HANDLER.getPassValidityRange(spieler.private.geburtsdatum, lv.sportart, sportJahr);
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = validityRange.until;
        path = 'dates.gesperrtAb';
        dbObject[path] = '';
    // get new memberships
        dbObject.memberships = SPIELER_MEMBERSHIP_HANDLER.getVerlaengerung(spieler, validityRange);
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( JSON.parse(JSON.stringify(spieler.search)),
            dbObject.memberships, spieler.status );
    // return change object
        return dbObject
    }

    static getDataObjectForVerlaengerungCancel(spieler, pendingAction){
        let dbObject = { letzteAenderung: TimeStamp.getGMTTimestamp()};
        let memberships = pendingAction.undo_pending.memberships;
    // set dates and status
        let path = 'dates.lastSportTag';
        dbObject[path] = SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(memberships);
        path = 'dates.gesperrtAb';
        dbObject[path] = pendingAction.undo_pending.gesperrtAb??'';
    // reset memberships
        dbObject.memberships = memberships;
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership( JSON.parse(JSON.stringify(spieler.search)),
                                                                                dbObject.memberships, spieler.status );
    // return change object
        return dbObject
    }

// UMMELDUNG
        /* nur möglich:
            - für das kommende Sportjahr, wenn der Spieler im laufenden Sportjahr aktiv ist
            - für das laufende Sportjahr nur im Juli, wenn der Spieler im laufenden Sportjahr noch aktiv wäre
           nicht möglich
            - falls inaktiv im laufenden Sportjahr, egal ob bis Juni oder im Juli => NEUANMELDUNG
           Aufruf aus:
            - aktuell aktivem Verein
            - aus der Suche mit dem Vorschlag für Ummeldejahr
           Aktiver Verein kommt daher immer aus dem SPIELER_MEMBERSHIP_HANDLER
            - wenn kein aktiver Verein oder Deadline abgelaufen => "keine Ummeldung möglich"
         */
    static getDataObjectForUmmeldung(spieler, lv, newVerein, newPassNr){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = {};
        let validityRange = SPIELER_CHANGE_HANDLER.getPassValidityRange(spieler.private.geburtsdatum, lv.sportart,
                                                                        store.state.local.sportJahr.ummeldung.ummeldeJahr);
    // get new memberships
        dbObject.memberships = SPIELER_MEMBERSHIP_HANDLER.getUmmeldung(spieler, lv, newVerein, validityRange, newPassNr);
    // set new lastSportTag
        let path = 'dates.lastSportTag';
        dbObject[path] = validityRange.until;
        path = 'dates.gesperrtAb';
        dbObject[path] = '';
    // set active in case spieler is currently inactive
        dbObject.status = 'aktiv';
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
                                spielerTemp.search, dbObject.memberships, 'aktiv' );
    // always: set search key for ade/dsv docs (because of lv-change or inaktiv => aktiv change
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(
                                dbObject.search, spielerTemp.ade, spielerTemp.dsv, 'aktiv');
    // if landesverband change => new passNr => set passStatus
        if ( dbObject.memberships.filter( membership => membership.passNr === 'ummeldung' ).length > 0 ) {
            dbObject.search.passStatus = 'ummeldung';
        }
    // return change object
        return dbObject
    }

    static getDataObjectForUmmeldungCancel(actionItem, spieler){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = {};
    // reset to old memberships and status
        dbObject.memberships = actionItem.undo_pending.memberships;
        dbObject.status = actionItem.undo_pending.status;
    // set old lastSportTag
        let path = 'dates.lastSportTag';
        dbObject[path] = SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(dbObject.memberships);
        path = 'dates.gesperrtAb';
        dbObject[path] = pendingAction.undo_pending.gesperrtAb??'';
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
                        spielerTemp.search, dbObject.memberships, actionItem.undo_pending.status );
        dbObject.search.passStatus = '';
    // always: reset search key for ade/dsv docs (because of lv-change or aktiv => inaktiv change
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBestaetigungenStatus(
                        dbObject.search, spielerTemp.ade, spielerTemp.dsv, actionItem.undo_pending.status);
    // return change object
        return dbObject;
    }

// LEIHE
    static getDataObjectForLeihe(spieler, lv, newVerein){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = {};
    // get new memberships
        dbObject.memberships = spielerTemp.memberships;
        dbObject.memberships.push({
            from: store.state.local.sportJahr.current.from,
            until:  store.state.local.sportJahr.current.until,
            leihe: true,
            passNr: 'beantragt',
            lvVereinId: lv.id + newVerein,
        });
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
            spielerTemp.search, dbObject.memberships, 'aktiv' );
    // return change object
        return dbObject
    }

    static getDataObjectForLeihePassNr(spieler, passNr){
        let dbObject = {};
        const currentSportJahr = store.state.local.sportJahr.current;
    // get new memberships
        dbObject.memberships = JSON.parse(JSON.stringify(spieler.memberships));
        for ( let i = 0; i < dbObject.memberships.length; i++ ) {
            if ( dbObject.memberships[i].leihe &&
                 dbObject.memberships[i].from === currentSportJahr.from &&
                dbObject.memberships[i].until === currentSportJahr.until
            ) {
                dbObject.memberships[i].passNr = passNr;
                break;
            }
        }
    // add passPrint parameters
        dbObject = SPIELER_CHANGE_HANDLER.addPassPrintParameterToDbObject(dbObject, true, false)
    // return change object
        return dbObject
    }

    static getDataObjectForLeiheDelete(spieler, from, until){
        let spielerTemp = JSON.parse(JSON.stringify(spieler));
        let dbObject = {};
        //const currentSportJahr = store.state.local.sportJahr.current;
    // delete memberships
        dbObject.memberships = JSON.parse(JSON.stringify(spieler.memberships));
        for ( let i = 0; i < dbObject.memberships.length; i++ ) {
            if ( dbObject.memberships[i].leihe &&
                dbObject.memberships[i].from === from &&
                dbObject.memberships[i].until === until
            ) {
                dbObject.memberships.splice(i,1);
                break;
            }
        }
    // re-construct search
        dbObject.search = SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(
            spielerTemp.search, dbObject.memberships, 'aktiv' );
        return dbObject
    }

// PASS PRINT
    static addPassPrintParameterToDbObject(dbObject, isSpielerPass, isDuplikat){
        //const ts = TimeStamp.getGMTTimestamp()
        //dbObject.tsLastPassPrint = ts
        //if ( isSpielerPass ) dbObject.tsLastPlayerPassPrint = ts
        dbObject.waitingForPassPrint = true
        dbObject.waitingForPlayerPassPrint = isSpielerPass
        dbObject.printIsDuplikat = isDuplikat
        return dbObject
    }
    static async clearSpielerPassPrint(dbObject, spielerId){
        //const ts = TimeStamp.getGMTTimestamp()
        //dbObject.tsLastPassPrint = ts
        //if ( isSpielerPass ) dbObject.tsLastPlayerPassPrint = ts
        const spieler = await FirebaseRead.readSingleDoc('spieler', spielerId)
        let waitingForPassPrint = false
        if ( spieler.roles ) {
            Object.keys(spieler.roles).forEach( (roleKey) => {
                const role = spieler.roles[roleKey]
                if ( role.waitingForPassPrint ) waitingForPassPrint = true
            });
        }
        dbObject.waitingForPassPrint = waitingForPassPrint
        dbObject.waitingForPlayerPassPrint = false
        dbObject.printIsDuplikat = false
        return dbObject
    }

// PASS VALIDITY
    static getPassValidityRange(birthday, sportart, sportJahr){//birthday, sportart
        let yearObject = sportJahr ? sportJahr : store.state.local.sportJahr.current;
        let validityRange = {from: '', until: ''};
        validityRange.from = JSON.parse(JSON.stringify( yearObject.from ));
        let currentYear = validityRange.from.split('-')[0];
        let endYear = parseInt(currentYear) + SPIELER_CHANGE_HANDLER.getDuration(validityRange.from, birthday, sportart);
        validityRange.until = endYear + "-06-30";
        return validityRange;
    }

        static getDuration(beginOfSportjahr, birthday, sportart){
        // Bowling: am Beginn des Sportjahres noch nicht 23 Jahre => 5 Jahre, sonst 15 Jahre
            if ( sportart ==='bowling' ) {
                let jahre = parseInt(beginOfSportjahr.substr(0,4)) - parseInt(birthday.substr(0,4));
                if ( jahre > 23 ) { return 15; }
                if ( jahre < 23 ) { return 5; }
                if ( jahre === 23 ) {
                    let birthdayThisYear = beginOfSportjahr.substr(0,4) + birthday.substr(4);
                    return birthdayThisYear < beginOfSportjahr ? 15 : 5;
                }
            } else {
        // Kegeln: am Beginn des Sportjahres noch nicht 23 Jahre => 5 Jahre, sonst 15 Jahre
                let jahre = parseInt(beginOfSportjahr.substr(0,4)) - parseInt(birthday.substr(0,4));
                if ( jahre > 23 ) { return 15; }
                if ( jahre < 23 ) { return 5; }
                if ( jahre === 23 ) {
                    let birthdayThisYear = beginOfSportjahr.substr(0,4) + birthday.substr(4);
                    return birthdayThisYear < beginOfSportjahr ? 15 : 5;
                }
            }
        }

// DATES
    static dates_update(spieler) {
        let dates = JSON.parse(JSON.stringify(spieler.dates));
        let firstAndLastSportTag = SPIELER_CHANGE_HANDLER.getFirstAndLastSportTag(spieler.memberships);
        dates.firstSportTag = firstAndLastSportTag.firstSportTag;
        dates.lastSportTag = firstAndLastSportTag.lastSportTag;
        if ( spieler.private.geburtsdatum ) {
            dates.akJahr = parseInt(spieler.private.geburtsdatum.substring(0,4));
            dates.akHJ = parseInt(spieler.private.geburtsdatum.substring(5,7)) <= 6 ? 1 : 2;
        }
        return dates;
    }
        static getFirstAndLastSportTag(memberships) {
            let result = { firstSportTag: '', lastSportTag: ''};
            memberships.forEach( (membership) => {
                if ( !result.firstSportTag || result.firstSportTag < membership.from) {
                    result.firstSportTag = membership.from;
                }
                if ( !result.lastSportTag || result.lastSportTag < membership.until) {
                    result.lastSportTag = membership.until;
                }
            });
            return result;
        }

// SEARCH KEY constructors
    static search_setBasedOnMembership( search, memberships, status ){
        search.membershipYears = SPIELER_CHANGE_HANDLER.search_setMembershipYears(memberships);
        search.passNumbers = SPIELER_CHANGE_HANDLER.search_setPassNumbers(memberships);
        search.leihen = SPIELER_CHANGE_HANDLER.search_setLeihen(memberships);
        search.lastAktiv = status === 'inaktiv' ? {} : SPIELER_CHANGE_HANDLER.search_setLastAktiv(memberships);
        /*const lastAktivKey = SPIELER_CHANGE_HANDLER.search_setLastActive(memberships);
        search.lastAktiv = {[lastAktivKey]: true};*/
        if ( status === 'inaktiv' ) {
            let lastMembership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(memberships);
            search.inaktiv = { [lastMembership.lvVereinId]: true };
            //delete search.lastAktiv;
        } else if ( search.inaktiv ) {
            delete search.inaktiv;
        }
        return search;
    }


        static search_setMembershipYears(memberships){
            let membershipYears = {};
            memberships.forEach( (membership) => {
                membershipYears = SPIELER_CHANGE_HANDLER.search_setMembershipYearsForMembership(membershipYears, membership)
            });
            return membershipYears;
        }
            static search_setMembershipYearsForMembership(membershipYears, membership){
                let firstYear = SPIELER_CHANGE_HANDLER.getYearFromDateString(membership.from);
                let lastYear = SPIELER_CHANGE_HANDLER.getYearFromDateString(membership.until);
                if ( firstYear === lastYear ) { firstYear--; }
                for ( let i = firstYear; i < lastYear; i++ ) {
                    let end = i + 1;
                    let key = membership.lvVereinId + '_' + i + '_' + end;
                    membershipYears[key] = true;
                }
                return membershipYears;
            }

        static search_setPassNumbers(memberships){
            let passNumbers = {};
            memberships.forEach( (membership) => {
                if ( membership.passNr !== 'beantragt' &&
                     membership.passNr !== 'in Bearbeitung' &&
                     membership.passNr !== 'ummeldung' ) {
                    passNumbers[membership.passNr] = true;
                }
            });
            return passNumbers;
        }

        static search_setLeihen(memberships){
            let leihen = {};
            memberships.forEach( (membership) => {
                if ( membership.leihe ) {
                    let firstYear = SPIELER_CHANGE_HANDLER.getYearFromDateString(membership.from);
                    let lastYear = SPIELER_CHANGE_HANDLER.getYearFromDateString(membership.until);
                    if ( firstYear === lastYear ) { firstYear--; }
                    let key = firstYear + '_' + lastYear;
                    leihen[key] = membership.lvVereinId;
                }
            });
            return leihen;
        }

        static search_setLastAktiv(memberships) {
            let lastVerein = '';
            let lastUntil = '';
            memberships.forEach( (membership) => {
                if ( (lastUntil === '' || membership.until > lastUntil) && !membership.leihe ) {
                    lastUntil = membership.until;
                    lastVerein = membership.lvVereinId;
                }
            });
            const lv = lastVerein.substr(0,2);
            return { [lastVerein]: lastUntil, [lv]: lastUntil };
        }

        /*static search_setLastActive(memberships) {
            return memberships.sort((b, a) => a.until > b.until ? 1 : -1)[0].lvVereinId;
        }*/

    static search_setPassStatus(search, status){
        // 'beantragt', 'in Bearbeitung', '' => erledigt
        search.passStatus = status;
        return search;
    }

    static search_setBestaetigungenStatus(search, ade, dsv, status){
        let lv = '';
        if ( !search.lastAktiv ) {
            // important: never delete!!!
            console.error ("search_setBestaetigungenStatus: DATA Error in Spieler, search.lastAktiv not set!");
        }
        Object.keys(search.lastAktiv).forEach( (key) => {
            if ( key.length === 2 ) { lv = key }
        });
        /*const adeField = 'ade' + lv;
        const dsvField = 'dsv' + lv;
        search.docs = status === 'inaktiv' ? {} : {
            [adeField]: !( status === 'aktiv' && !ade ),
            [dsvField]: !( status === 'aktiv' && !dsv ),
        };*/
        if ( status === 'inaktiv' ) {
            search.docs = '';
        } else {
            const pos1 = !ade ? '1' : '0';
            const pos2 = !dsv ? '1' : '0';
            search.docs = lv + '_' + pos1 + '_' + pos2;
        }
        return search;
    }

    static search_setUserUnique(search, spieler ){
        search.userUnique = spieler.vorname.trim() + '_' + spieler.nachname.trim() + '_' + spieler.private.geburtsdatum;
        return search;
    }

}
